import React from 'react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Check, Sparkles } from 'lucide-react';
import { productCatalog } from '../productCatalog';

const machineImages = [
  {
    src: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/udru6h5f_WhatsApp%20Image%202026-03-17%20at%204.46.49%20AM%20%282%29.jpeg",
    alt: "SWF Multi-Head Embroidery Machine"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/j63ox558_WhatsApp%20Image%202026-03-17%20at%204.46.49%20AM%20%281%29.jpeg",
    alt: "SWF Embroidery Machine - Full Setup"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_c880b918-949e-40d2-9154-d5ab9798831b/artifacts/lgp6zel9_WhatsApp%20Image%202026-03-17%20at%204.46.49%20AM.jpeg",
    alt: "SINSIM G-TECH Embroidery Machine"
  }
];

const EmbroideryShowcase = () => {
  const { embroideryService } = productCatalog;

  return (
    <section className="py-20 bg-white" data-testid="embroidery-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left - Content */}
          <div className="space-y-6">
            <div className="inline-flex items-center">
              <Badge className="bg-amber-600 text-white px-4 py-2 text-sm font-semibold">
                <Sparkles className="h-4 w-4 mr-2" />
                IN-HOUSE SERVICE
              </Badge>
            </div>

            <h2 className="text-4xl font-bold text-gray-900 leading-tight">
              {embroideryService.title}
            </h2>

            <div className="space-y-4">
              {embroideryService.features.map((feature, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <div className="flex-shrink-0 mt-1">
                    <Check className="h-6 w-6 text-amber-600" />
                  </div>
                  <span className="text-lg text-gray-700 font-medium">{feature}</span>
                </div>
              ))}
            </div>

            <div className="pt-6">
              <p className="text-xl text-blue-900 font-semibold italic mb-6">
                "{embroideryService.tagline}"
              </p>
              <Button
                size="lg"
                className="bg-blue-900 hover:bg-blue-800 text-white px-10 py-6 text-lg"
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              >
                Get a Quote
              </Button>
            </div>
          </div>

          {/* Right - Image Gallery */}
          <div className="space-y-3">
            <div className="grid grid-cols-3 gap-3">
              {machineImages.map((img, i) => (
                <div key={i} className="rounded-xl overflow-hidden shadow-md border border-gray-200">
                  <img
                    src={img.src}
                    alt={img.alt}
                    className="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmbroideryShowcase;
